import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProjectQueryParam, ProjectForecast } from "models/project";
import ProjectStatus from "models/project-status";
import Department from "models/department";
import Branch from "models/branch";
import Client from "models/client";
import Employee from "models/employee";
import ClientProjectFinance from "models/project-finance";

export interface ProjectForecastSliceState {
    projects: ProjectForecast[];
    projectCount: number;
    query: IProjectQueryParam;
    projectStatus: ProjectStatus[];
    departments: Department[];
    branches: Branch[];
    customers: Client[];
    projectManagers: Employee[];
}

export const initialState: ProjectForecastSliceState = {
    projects: [],
    projectCount: 0,
    query: {
        page: 0,
        limit: Number.MAX_SAFE_INTEGER,
        clientIds: [],
        projectManagerIds: [],
        branchIds: [],
        departmentIds: [],
    } as IProjectQueryParam,
    projectStatus: [],
    departments: [],
    branches: [],
    customers: [],
    projectManagers: [],
};

const ProjectForecastSliceState = createSlice({
    name: "project-forecast-slice",
    initialState,
    reducers: {
        setProjects(state, { payload }: PayloadAction<ProjectForecast[]>) {
            state.projects = payload;
        },

        setProjectCount(state, { payload }: PayloadAction<number>) {
            state.projectCount = payload;
        },
        setQuery(state, { payload }: PayloadAction<IProjectQueryParam>) {
            state.query = payload;
        },
        setSearchFields(state, { payload }: PayloadAction<{
            projectStatus: ProjectStatus[],
            departments: Department[],
            branches: Branch[],
            customers: Client[],
            projectManagers: Employee[],
        }>) {
            state.projectStatus = payload.projectStatus;
            state.departments = payload.departments;
            state.branches = payload.branches;
            state.customers = payload.customers;
            state.projectManagers = payload.projectManagers;
        },
        mergeProjectFinacnes(
            state,
            { payload }: PayloadAction<ClientProjectFinance[]>
        ) {

            if (!payload || payload.length === 0) return;

            // Ignore summary row during merge
            const projects = state.projects.filter(p => p.id !== "__summary__");

            // 1️⃣ Merge changes into projects
            payload.forEach(pf => {
                const project = projects.find(p => p.id === pf.projectId);
                if (!project) return;

                const index = project.projectFinances.findIndex(
                    x => x.fiscalPeriod === pf.fiscalPeriod
                );

                if (index >= 0) {
                    // update existing period
                    project.projectFinances[index].forecastAmount = pf.forecastAmount;
                } else {
                    // insert missing period
                    project.projectFinances.push({
                        fiscalPeriod: pf.fiscalPeriod,
                        forecastAmount: pf.forecastAmount as any,
                    } as any);
                }
            });


            state.projects = projects;
        }

    },
});

export const {
    setProjects,
    setProjectCount,
    setQuery,
    setSearchFields,
    mergeProjectFinacnes,
} = ProjectForecastSliceState.actions;

export default ProjectForecastSliceState.reducer;
